import simplecounter from "../../../assets/images/portfolio/simplecounter.webp";
import navbar from "../../../assets/images/portfolio/navbar.webp";
import modal from "../../../assets/images/portfolio/modal.webp";
import sayisal from "../../../assets/images/portfolio/sayisal.webp";
import video from "../../../assets/images/portfolio/video.webp";
import slider from "../../../assets/images/portfolio/slider.webp";
import colorflipper from "../../../assets/images/portfolio/colorflipper.webp";
import tabs from "../../../assets/images/portfolio/tabs.webp";
import varmisin from "../../../assets/images/portfolio/varmisin.webp";
import loremipsum from "../../../assets/images/portfolio/loremipsum.webp";
import sidebar from "../../../assets/images/portfolio/sidebar.webp";
import questions from "../../../assets/images/portfolio/questions.webp";
import scroll from "../../../assets/images/portfolio/scroll.webp";
import countdown from "../../../assets/images/portfolio/countdown.webp";
import reviews from "../../../assets/images/portfolio/reviews.webp";
import menu from "../../../assets/images/portfolio/menu.webp";
import grocerybud from "../../../assets/images/portfolio/grocerybud.webp";
import country from "../../../assets/images/portfolio/country.webp";
import musicplayer from "../../../assets/images/portfolio/musicplayer.webp";
import apsiyonbenzeri from "../../../assets/images/portfolio/apsiyonbenzeri.webp";
import todoapp from "../../../assets/images/portfolio/todoapp.webp";
import quiz from "../../../assets/images/portfolio/quiz.webp";
import calculator from "../../../assets/images/portfolio/calculator.webp";
import ogalift from "../../../assets/images/portfolio/ogalift.webp";
import dogapelet from "../../../assets/images/portfolio/dogapelet.webp";
import korfeztwo from "../../../assets/images/portfolio/korfeztwo.webp";
import minimalistlp from "../../../assets/images/portfolio/minimalistlp.webp";

const vanilla_js_projects_data = [
  {
    img: minimalistlp,
    isResponsive: true,
    title: "Mimimalist Landing Page",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/minimalist-landing-page",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://minimalistlandingpage.surge.sh/",
    },
  },
  {
    img: korfeztwo,
    isResponsive: true,
    title: "Körfez Güvenlik",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: false,
      link: null,
    },
    isSeeBtn: {
      isThere: true,
      link: "https://korfezguvenlik.com/",
    },
  },
  {
    img: dogapelet,
    isResponsive: true,
    title: "Doğa Pelet",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: false,
      link: null,
    },
    isSeeBtn: {
      isThere: true,
      link: "https://dogapelet.surge.sh/",
    },
  },
  {
    img: ogalift,
    isResponsive: true,
    title: "Ogalift Africa",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: false,
      link: null,
    },
    isSeeBtn: {
      isThere: true,
      link: "https://ogalift.com/",
    },
  },
  {
    img: calculator,
    isResponsive: false,
    title: "Calculator App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/calculator-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "http://calculator1app.surge.sh/",
    },
  },
  {
    img: quiz,
    isResponsive: false,
    title: "Quiz App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/quiz-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "http://quiz1app.surge.sh/",
    },
  },
  {
    img: todoapp,
    isResponsive: false,
    title: "Todo App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/todo-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://todo1app.surge.sh/",
    },
  },
  {
    img: musicplayer,
    isResponsive: false,
    title: "Music Player App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/music-player-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://musicplayerapp.surge.sh/",
    },
  },

  {
    img: country,
    isResponsive: false,
    title: "Country App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/country-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://country1app.surge.sh/",
    },
  },
  {
    img: grocerybud,
    isResponsive: false,
    title: "Grocery Bud App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/grocery-bud-app",
    },
    isSeeBtn: {
      isThere: false,
      link: null,
    },
  },
  {
    img: apsiyonbenzeri,
    isResponsive: false,
    title: "Apsiyon Benzeri",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/apsiyon-benzeri",
    },
    isSeeBtn: {
      isThere: false,
      link: null,
    },
  },
  {
    img: menu,
    isResponsive: false,
    title: "Menu App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/menu-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "http://menuapp.surge.sh/",
    },
  },
  {
    img: reviews,
    isResponsive: false,
    title: "Reviews App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/reviews-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://reviewsapp.surge.sh/",
    },
  },
  {
    img: countdown,
    isResponsive: false,
    title: "Countdown App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/countdown-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://countdown1app.surge.sh/",
    },
  },
  {
    img: scroll,
    isResponsive: false,
    title: "Scroll App",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/scroll-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "http://scrollapp.surge.sh/",
    },
  },
  {
    img: questions,
    isResponsive: false,
    title: "Questions App",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/questions-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://questionsapp.surge.sh/",
    },
  },
  {
    img: sidebar,
    isResponsive: false,
    title: "Sidebar App",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/sidebar-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "http://sidebarapp.surge.sh/",
    },
  },
  {
    img: loremipsum,
    isResponsive: false,
    title: "Lorem Ipsum App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/loremipsum-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://loremipsumapp.surge.sh/",
    },
  },
  {
    img: varmisin,
    isResponsive: false,
    title: "Var Mısın Yok Musun App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/varmisin-yokmusun-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://varmisinyokmusunapp.surge.sh/",
    },
  },
  {
    img: tabs,
    isResponsive: false,
    title: "Tabs App",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/tabs-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://tabsapp.surge.sh/",
    },
  },
  {
    img: colorflipper,
    isResponsive: false,
    title: "Color Flipper App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/color-flipper-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://colorflipperapp.surge.sh/",
    },
  },
  {
    img: slider,
    isResponsive: false,
    title: "Slider App",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/slider-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "http://sliderapp.surge.sh/",
    },
  },
  {
    img: video,
    isResponsive: false,
    title: "Video App",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/video-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://video1app.surge.sh/",
    },
  },
  {
    img: modal,
    isResponsive: false,
    title: "Modal App",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/modal-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://modalapp.surge.sh/",
    },
  },
  {
    img: navbar,
    isResponsive: true,
    title: "Navbar App",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/navbar-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://navbarapp.surge.sh/",
    },
  },
  {
    img: sayisal,
    isResponsive: false,
    title: "Sayısal Loto App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/sayisal-loto-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://sayisallotoapp.surge.sh/",
    },
  },
  {
    img: simplecounter,
    isResponsive: false,
    title: "Simple Counter App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/simple-counter-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://simplecounterapp.surge.sh/",
    },
  },
];

export default vanilla_js_projects_data;
